import { mockUserRiskItems, mockUserRiskSummary } from '@/__mocks__';

const userRiskApi = {
  requestList() {
    return new Promise((resolve) => {
      const items = 25;
      const response = {
        data: {
          users: mockUserRiskItems(items),
          paging: {
            next_cursor: 'MjAyMS0wOC0wMVQxNToyNTo0OS4zODg3MjNa',
            next_link:
              'https://localhost/items?cursor=MjAyMS0wOC0wMVQxNToyNTo0OS4zODg3MjNa',
            total_count: items,
          },
        },
      };
      setTimeout(() => {
        resolve(response);
      }, 100);
    });
  },
  requestSummary() {
    return new Promise((resolve) => {
      const response = { data: mockUserRiskSummary() };
      setTimeout(() => {
        resolve(response);
      }, 100);
    });
  },
};

export default userRiskApi;
